import { mainnetNetworks } from '@/constants/mock_networks.constants';
import { sortBy } from 'lodash';
import { testnetNetworks } from './testnetNetworks';

export const supportedNetworks = [
  ...sortBy([...mainnetNetworks], 'order_on_main_page'),
  ...testnetNetworks,
  {
    id: crypto.randomUUID(),
    name: 'Aptos',
    network_image_url:
      window.location.origin +
      require('@/Assets/Icons/networks/aptos.svg').default,
    tag: 'coming soon',
    order_on_main_page: 927,
    is_coming_soon: true,
    is_testnet: false,
  },
];
